
  (function() {
    const root = document.getElementById("focus-image-carousel-template--20782090715178__focus_image_carousel_wTxHp7");
    if (!root || root.dataset.focusImageCarouselReady === 'true') return;

    root.dataset.focusImageCarouselReady = 'true';

    const slides = Array.from(root.querySelectorAll('[data-focus-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-focus-dot]'));
    const stage = root.querySelector('[data-focus-stage]');
    const playPauseButton = root.querySelector('[data-focus-playpause]');
    const slideCount = slides.length;
    const playLabel = "播放轮播";
    const pauseLabel = "暂停轮播";
    const autoplayEnabled = root.dataset.autoplay === 'true';
    const autoplayDelay = Math.max(2000, Number(root.dataset.autoplaySpeed) || 5000);
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let autoplayTimer = null;
    let isPlaying = false;
    let swipeStartX = 0;
    let swipeStartY = 0;
    let activePointerId = null;
    let isSwipeTracking = false;
    let shouldSuppressClick = false;
    let progressAnimation = null;
    const supportsWebAnimations = 'animate' in document.createElement('span');

    if (!slideCount) return;

    function normalizeIndex(index) {
      return ((index % slideCount) + slideCount) % slideCount;
    }

    function getRelativeIndex(index) {
      let offset = index - activeIndex;
      if (offset > slideCount / 2) offset -= slideCount;
      if (offset < slideCount / -2) offset += slideCount;
      return offset;
    }

    function renderCarousel() {
      slides.forEach((slide, index) => {
        const offset = getRelativeIndex(index);
        slide.classList.remove('is-active', 'is-prev', 'is-next', 'is-far-prev', 'is-far-next');
        slide.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
        slide.tabIndex = offset === 0 ? 0 : -1;
        slide.querySelectorAll('a').forEach((link) => {
          if (offset === 0) {
            link.removeAttribute('tabindex');
          } else {
            link.tabIndex = -1;
          }
        });

        if (offset === 0) {
          slide.classList.add('is-active');
        } else if (offset === -1) {
          slide.classList.add('is-prev');
        } else if (offset === 1) {
          slide.classList.add('is-next');
        } else if (offset < -1) {
          slide.classList.add('is-far-prev');
        } else {
          slide.classList.add('is-far-next');
        }
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      runProgress();
    }

    function runProgress() {
      if (progressAnimation) {
        progressAnimation.cancel();
        progressAnimation = null;
      }

      const activeDot = dots[activeIndex];
      const fill = activeDot ? activeDot.querySelector('[data-focus-dot-fill]') : null;
      if (!fill) return;

      fill.style.transform = '';

      if (isPlaying && supportsWebAnimations) {
        // Fill the active pill over one autoplay interval, in sync with the timer.
        progressAnimation = fill.animate(
          [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
          { duration: autoplayDelay, easing: 'linear', fill: 'forwards' }
        );
      } else {
        // Paused, autoplay off, or no Web Animations support: show the full pill.
        fill.style.transform = 'scaleX(1)';
      }
    }

    function goToSlide(index) {
      activeIndex = normalizeIndex(index);
      renderCarousel();
      if (isPlaying) restartAutoplayTimer();
    }

    function autoplayTick() {
      activeIndex = normalizeIndex(activeIndex + 1);
      renderCarousel();
    }

    function restartAutoplayTimer() {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      autoplayTimer = window.setInterval(autoplayTick, autoplayDelay);
    }

    function startAutoplay() {
      if (slideCount < 2) return;
      isPlaying = true;
      restartAutoplayTimer();
      runProgress();
      updatePlayState();
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
      isPlaying = false;
      // Freeze the progress bar where it is.
      if (progressAnimation) progressAnimation.pause();
      updatePlayState();
    }

    function updatePlayState() {
      if (!playPauseButton) return;
      playPauseButton.classList.toggle('is-playing', isPlaying);
      playPauseButton.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      playPauseButton.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function beginSwipe(clientX, clientY) {
      if (!isMobileViewport() || slideCount < 2) return;

      swipeStartX = clientX;
      swipeStartY = clientY;
      isSwipeTracking = true;
    }

    function finishSwipe(clientX, clientY, event) {
      if (!isSwipeTracking) return;

      const deltaX = clientX - swipeStartX;
      const deltaY = clientY - swipeStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);
      isSwipeTracking = false;

      if (absDeltaX < 36 || absDeltaX < absDeltaY * 1.25) return;

      if (event.cancelable) event.preventDefault();
      shouldSuppressClick = true;
      window.setTimeout(() => {
        shouldSuppressClick = false;
      }, 300);

      goToSlide(activeIndex + (deltaX < 0 ? 1 : -1));
    }

    function cancelSwipe() {
      activePointerId = null;
      isSwipeTracking = false;
    }

    if (stage && window.PointerEvent) {
      stage.addEventListener('pointerdown', (event) => {
        if (event.button !== undefined && event.button !== 0) return;

        activePointerId = event.pointerId;
        beginSwipe(event.clientX, event.clientY);

        if (isSwipeTracking && stage.setPointerCapture) {
          stage.setPointerCapture(event.pointerId);
        }
      });

      stage.addEventListener('pointerup', (event) => {
        if (activePointerId !== null && event.pointerId !== activePointerId) return;

        activePointerId = null;
        finishSwipe(event.clientX, event.clientY, event);
      });

      stage.addEventListener('pointercancel', cancelSwipe);
    } else if (stage) {
      stage.addEventListener('touchstart', (event) => {
        const touch = event.touches[0];
        if (!touch) return;

        beginSwipe(touch.clientX, touch.clientY);
      }, { passive: true });

      stage.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;

        finishSwipe(touch.clientX, touch.clientY, event);
      });

      stage.addEventListener('touchcancel', cancelSwipe);
    }

    playPauseButton?.addEventListener('click', () => {
      if (isPlaying) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => goToSlide(Number(dot.dataset.slideIndex)));
    });

    slides.forEach((slide) => {
      slide.addEventListener('click', (event) => {
        if (shouldSuppressClick) {
          event.preventDefault();
          event.stopPropagation();
          shouldSuppressClick = false;
          return;
        }

        const clickedIndex = Number(slide.dataset.slideIndex);
        if (clickedIndex !== activeIndex) {
          event.preventDefault();
          goToSlide(clickedIndex);
        }
      });
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') goToSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') goToSlide(activeIndex + 1);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
        if (progressAnimation) progressAnimation.pause();
      } else if (isPlaying) {
        restartAutoplayTimer();
        runProgress();
      }
    });

    renderCarousel();

    if (autoplayEnabled && !prefersReducedMotion && slideCount > 1) {
      startAutoplay();
    } else {
      updatePlayState();
    }
  })();
